import React, { useEffect, useState } from "react";
import { Offcanvas, Spinner } from "react-bootstrap";
import edit from "../../../assets/Asssignment/edit.png";
import trash from "../../../assets/Asssignment/delete.png";
import closeoff from "../../../assets/Asssignment/close.png";
import { viewExpenseDetAPI } from "./expense_api";

const ExpenseHistoryView = ({ id, show, handleClose }) => {
  const [expenseView, setExpenseView] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      getExpenseView();
    }
  }, [id]);

  const getExpenseView = async () => {
    setLoading(true);
    try {
      const response = await viewExpenseDetAPI(id);
      if (response.data?.success) {
        setExpenseView(response.data.history);
      } else {
        setExpenseView(null);
      }
    } catch (err) {
      setExpenseView(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement="end" style={{ width: "520px" }}>
      <Offcanvas.Header closeButton={false} className="d-flex justify-content-between align-items-center p-0">
        <Offcanvas.Title className="bg-grey w-100 p-3 d-flex flex-wrap justify-content-center align-items-center justify-content-xl-between">
          <div>
            <p className="m-0 fs-20 fw-800 mb-1">{expenseView?.lic_no || "-"}</p>
            <div className="d-flex align-items-center">
              <span className="me-2 text-muted-grey fs-13 fw-600">{expenseView?.name || "-"}</span>
              <span className="me-2" style={{ color: "#D9D9D9" }}>
                •
              </span>
              <span className="border-0 bg-white text-dark-purple py-1 px-4 rounded-pill fs-13 fw-400">
                <span className="text-muted-grey"> VIN : </span>
                {expenseView?.vin || "-"}
              </span>
            </div>
          </div>
          <div className="d-flex gap-3">
           {/*  <img src={edit} alt="edit" className="cursor-pointer" />
            <img src={trash} alt="trash" className="cursor-pointer" /> */}
            <img src={closeoff} alt="closeoff" className="cursor-pointer" onClick={handleClose} />
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "100%" }}>
            <Spinner animation="border" />
          </div>
        ) : expenseView ? (
          <div>
            {/* Current & Last KM */}
            <div className="row my-3">
              <div className="col-xl-6">
                <div className="bg-grey rounded-4 p-3 d-flex flex-column align-items-center justify-content-center">
                  <p className="fs-13 fw-400 text-purple">Current KM :</p>
                  <p className="fs-14 fw-600 m-0">{expenseView.current_km || "-"}</p>
                </div>
              </div>
              <div className="col-xl-6 mt-3 mt-xl-0">
                <div className="bg-grey rounded-4 p-3 d-flex flex-column align-items-center justify-content-center">
                  <p className="fs-13 fw-400 text-purple">Last KM :</p>
                  <p className="fs-14 fw-600 m-0">{expenseView.last_km || "-"}</p>
                </div>
              </div>
            </div>
            <p className="m-0 fs-15 fw-600">Expenses details</p>
            {expenseView?.tabs?.length > 0 ? (
              expenseView.tabs.map((tab) => (
                <div key={tab.id} className="mb-4">
                  <p className="m-0 fs-15 fw-600">{tab.name}</p>
                  {tab.fields?.length > 0 ? (
                    <div className="table-container rounded-4 overflow-hidden my-3">
                      <table className="table table-borderless mb-0">
                        <tbody>
                          {tab.fields.map((field) => (
                            <tr key={field.id}>
                              <td className="fs-13 fw-500 w-50" style={{ color: "#49494B" }}>
                                {field.name}
                              </td>
                              <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                                {field.value ?? "-"}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p className="fs-13 text-muted">No data available</p>
                  )}
                </div>
              ))
            ) : (
              <p>No data available</p>
            )}
          </div>
        ) : (
          <p>No data available</p>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ExpenseHistoryView;
